/** @format */

import React, { Component } from 'react';
import { Menu, Image } from 'semantic-ui-react';
import Notifications from '../../Notifications/Notifications';
import './AppTopMenu.css';
import { observer, inject } from 'mobx-react';
import { auth } from '../../../firebase/config';
import Logo from '../../../public/images/logo.png';

@inject('UserStore')
@observer
class AppTopMenu extends Component {
  renderUserRealName = () => {
    const { UserStore } = this.props;

    if (!UserStore.user) {
      return null;
    }

    return [
      <Menu.Item as="a" name="notification" key="userFullName">
        <span
          className="profile-image"
          style={{
            backgroundImage:
              'url(https://cdn2.stylecraze.com/wp-content/uploads/2013/01/2162_Eyebrows-For-Square-Face-Shape_shutterstock_148055564.jpg)',
          }}
        ></span>
        &nbsp;&nbsp;&nbsp;
        {UserStore.userFullName}&nbsp;<small>({UserStore.roleIt})</small>
      </Menu.Item>,
      <Menu.Item
        key="logout button"
        as="a"
        name="notification"
        onClick={() => {
          auth.signOut();
        }}
      >
        Logout
      </Menu.Item>,
    ];
  };

  render() {
    return (
      <Menu borderless className="app-top-menu">
        <Menu.Menu position="left">
          <Menu.Item className="brand-item">
            <Image className="brand-img" src={Logo} size="small" />
          </Menu.Item>
        </Menu.Menu>
        <Menu.Menu position="right">
          <Notifications />
          {this.renderUserRealName()}
        </Menu.Menu>
      </Menu>
    );
  }
}

export default AppTopMenu;
